import React, {Fragment} from 'react';
import moment from 'moment'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {
    Grid,
    Avatar,
    CardContent,
    Tooltip, Box,
} from '@material-ui/core';
import {
    Link
} from "react-router-dom";
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import {Initials, caseCardClass} from '../../vendors/utils/common';

import {setSingleCase} from '../../vendors/actions/case'


interface OwnProps {

}

interface ConnectStateProps {
    States: any,
    CaseTypes: any,
    User: {
        first_name: string;
        last_name: string;
        isAuthenticated?: boolean;
    }
}

interface ConnectDispatchProps {
    setSidebarToggle?: (data: any) => void;
    setSidebarToggleMobile?: (data: any) => void;
    setSingleCase?: (data: any) => void;
}

const CaseItem = (props: any) => {
    const {data, CaseTypes} = props;
    const {interestedLawyers, matchedLawyer} = data;
    const caseType = CaseTypes.find((cT: any) => cT.id === data.case_type_id);
    const caseSubType = caseType ? caseType.subTypes.find((cT: any) => cT.id === data.case_sub_type_id) : null;
    const caseStatus = caseCardClass(data.status);
    const avatars = interestedLawyers.length ? interestedLawyers.map((lawyer: any, key: number) => {
        return <Avatar key={key} alt={lawyer.Lawyer.name}
                       color={'primary'}
                       src={lawyer.Lawyer.imageUrl}>{Initials(lawyer.Lawyer.name)}</Avatar>
    }).splice(0, 3) : [];
    if (interestedLawyers.length > 3) {
        avatars.push(<Tooltip key={4} title="">
            <Avatar className={'avatar-count'}>+{data.interestedLawyers.length - 3}</Avatar>
        </Tooltip>)
    }
    let lawyer: any = '';
    if (matchedLawyer) {
        lawyer = <Avatar alt={matchedLawyer.name}
                         color={'primary'}
                         src={matchedLawyer.imageUrl}>{Initials(matchedLawyer.name)}</Avatar>
    }

    const setSingleCase = () => {
        return props.setSingleCase(data);
    };

    return (
        <Fragment>
            <Grid className='case-item' item xs={12} lg={12} md={12}>
                <Link onClick={() => setSingleCase()} to={`/case/${data.case_uid}`} className="card card-box mb-4">
                    <div className={`card-indicator ${caseStatus.className}`}/>
                    <CardContent className="px-4 py-3 d-flex flex-wrap justify-content-between">
                        <div className="pb-3 pb-md-1 d-flex case-item-type">
                            <Box>
                                <span className='text-uppercase'>{caseType?.name}</span>, {caseSubType?.name}
                            </Box>
                            <Box className='pt-2 font-size-sm case-item-info'>
                                <div className={`case-item-status badge badge-${caseStatus?.className} px-2 text-uppercase`}>
                                    {caseStatus?.name}
                                </div>
                                <div className="case-item-date">
                                    <FontAwesomeIcon icon={['far', 'clock']} className="mr-1 ml-0 ml-lg-3"/>
                                    <span
                                        className='text-uppercase'>{moment(data.created_at).format('MMM DD, YYYY')}</span> at {moment(data.created_at).format('h:mm A')}
                                </div>
                            </Box>
                        </div>
                        <div className="d-flex justify-content-between width-sm-100">
                            <div className="d-flex align-items-center align-content-center cons-avatars">
                                {avatars.length && data.status === 1 ?
                                    <AvatarGroup>{avatars}</AvatarGroup>
                                    : null}
                                {matchedLawyer && data.status > 1} {
                                <AvatarGroup>{lawyer}</AvatarGroup>
                            }
                            </div>
                            <div className="expand-wrapper mt-auto my-sm-auto d-block pl-4">
                                <div className="expand-wrapper-icon"></div>
                            </div>
                        </div>
                    </CardContent>
                </Link>
            </Grid>
        </Fragment>
    );
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Layout, CaseTypes, States} = state;
    return {
        User,
        Layout,
        States,
        CaseTypes
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        setSingleCase: (data) => dispatch(setSingleCase(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseItem);
